export const ORDERS_COUNT_QUERY_KEY = 'ordersCount';
